/**
 * @generated SignedSource<<2e0d64f97783b572a248ef415cdf6407>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PortfolioProjectTextCoverStyle = "COLOR_BLACK" | "COLOR_BLUE" | "COLOR_GREEN" | "COLOR_ORANGE" | "COLOR_PURPLE" | "COLOR_SALMON" | "COLOR_WATERMELON" | "COLOR_WHITE" | "COLOR_YELLOW" | "SHAPE_COINS_DARK" | "SHAPE_COINS_LIGHT" | "SHAPE_COLLABORATION_DARK" | "SHAPE_COLLABORATION_LIGHT" | "SHAPE_FOCUS_DARK" | "SHAPE_FOCUS_LIGHT" | "SHAPE_GAIN_DARK" | "SHAPE_GAIN_LIGHT" | "SHAPE_STAIRS_DARK" | "SHAPE_STAIRS_LIGHT" | "SHAPE_WAVE_DARK" | "SHAPE_WAVE_LIGHT" | "SVG_BLUE" | "SVG_BLUE2" | "SVG_LINES_BLUE" | "SVG_LINES_GREEN" | "SVG_LINES_ORANGE" | "SVG_LINES_PURPLE" | "SVG_LINES_SALMON" | "SVG_LINES_YELLOW" | "SVG_WHITE" | "SVG_WHITE2" | "SVG_YELLOW" | "SVG_YELLOW2" | "VAPOR_GRADIENT_BLUE_DARK" | "VAPOR_GRADIENT_BLUE_LIGHT" | "VAPOR_GRADIENT_GREEN_DARK" | "VAPOR_GRADIENT_GREEN_LIGHT" | "VAPOR_GRADIENT_PURPLE_DARK" | "VAPOR_GRADIENT_PURPLE_LIGHT" | "VAPOR_GRADIENT_SALMON_DARK" | "VAPOR_GRADIENT_SALMON_LIGHT" | "VAPOR_GRADIENT_WATERMELON_DARK" | "VAPOR_GRADIENT_WATERMELON_LIGHT" | "VAPOR_GRADIENT_WHITE_DARK" | "VAPOR_GRADIENT_YELLOW_LIGHT" | "%future added value";
export type SocialMediaSiteNid = "ANGELLIST" | "ARTSTATION" | "AWWWARDS" | "BEHANCE" | "CARBONMADE" | "DEV" | "DEVIANTART" | "DRIBBBLE" | "FACEBOOK" | "FIVERR" | "FREELANCER" | "FWA" | "GITHUB" | "GITLAB" | "HASHNODE" | "INSTAGRAM" | "LINKEDIN" | "MEDIUM" | "PATREON" | "PINTEREST" | "SOUNDCLOUD" | "STACKOVERFLOW" | "TIKTOK" | "TUMBLR" | "TWITCH" | "TWITTER" | "UPWORK" | "VIMEO" | "VKONTAKTE" | "WNW" | "X" | "YOUTUBE" | "%future added value";
export type ProjectPageQuery$variables = {
  slug: string;
  url: string;
  username: string;
};
export type ProjectPageQuery$data = {
  readonly portfolioProjectBySlug: {
    readonly analyticsId: number;
    readonly blocknoteContent: any | null;
    readonly id: string;
    readonly organizations: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly name: string;
        };
      }>;
    };
    readonly otherPortfolioProjectsByUser: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly cover: {
            readonly __typename: "PortfolioProjectImageCover";
            readonly image: {
              readonly animated: boolean;
              readonly height: number;
              readonly id: string;
              readonly originalFormat: string;
              readonly sizeBytes: number;
              readonly uid: string;
              readonly width: number;
            };
          } | {
            readonly __typename: "PortfolioProjectTextCover";
            readonly style: PortfolioProjectTextCoverStyle;
          } | {
            readonly __typename: "PortfolioProjectVideoCover";
            readonly video: {
              readonly uid: string;
            };
          } | {
            // This will never be '%other', but we need some
            // value in case none of the concrete values match.
            readonly __typename: "%other";
          };
          readonly id: string;
          readonly organizations: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly id: string;
                readonly name: string;
              };
            }>;
          };
          readonly roles: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly id: string;
                readonly name: string;
              };
            }>;
          };
          readonly slug: string;
          readonly title: string;
        };
      }>;
    };
    readonly roles: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly name: string;
        };
      }>;
    };
    readonly slug: string;
    readonly title: string;
    readonly tools: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly name: string;
        };
      }>;
    };
    readonly userProfile: {
      readonly displayUsername: string;
      readonly externalLinks: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly label: string | null;
            readonly socialMediaSite: {
              readonly nid: SocialMediaSiteNid;
            } | null;
            readonly url: string;
          };
        }>;
      };
      readonly firstName: string | null;
      readonly generalInquiryCtaIsVisible: boolean;
      readonly id: string;
      readonly lastName: string | null;
      readonly portfolioProjects: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
          };
        }>;
      };
      readonly productizedServices: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
          };
        }>;
      };
      readonly " $fragmentSpreads": FragmentRefs<"Footer_userProfile">;
    };
    readonly visitorCanEdit: boolean;
    readonly " $fragmentSpreads": FragmentRefs<"Project_portfolioProject">;
  } | null;
  readonly userProfileByUsername: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"UserProfile_userProfile">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"IndependentPortfolioTemplates_queryFragment" | "UrlMetaData_queryFragment">;
};
export type ProjectPageQuery = {
  response: ProjectPageQuery$data;
  variables: ProjectPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "url"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "username"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "analyticsId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "blocknoteContent",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visitorCanEdit",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayUsername",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "generalInquiryCtaIsVisible",
  "storageKey": null
},
v12 = {
  "kind": "Literal",
  "name": "excludeDrafts",
  "value": true
},
v13 = [
  (v12/*: any*/)
],
v14 = [
  (v2/*: any*/)
],
v15 = {
  "alias": null,
  "args": (v13/*: any*/),
  "concreteType": "UserProfileProductizedServiceConnection",
  "kind": "LinkedField",
  "name": "productizedServices",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "UserProfileProductizedServiceEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProductizedService",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": (v14/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "productizedServices(excludeDrafts:true)"
},
v16 = [
  (v12/*: any*/),
  {
    "kind": "Literal",
    "name": "type",
    "value": "PROJECT"
  }
],
v17 = {
  "alias": null,
  "args": (v16/*: any*/),
  "concreteType": "UserProfilePortfolioProjectConnection",
  "kind": "LinkedField",
  "name": "portfolioProjects",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "UserProfilePortfolioProjectEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PortfolioProject",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": (v14/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "portfolioProjects(excludeDrafts:true,type:\"PROJECT\")"
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nid",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v22 = [
  (v2/*: any*/),
  (v21/*: any*/)
],
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "PortfolioProjectRoleConnection",
  "kind": "LinkedField",
  "name": "roles",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PortfolioProjectRoleEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Role",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": (v22/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "PortfolioProjectToolConnection",
  "kind": "LinkedField",
  "name": "tools",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PortfolioProjectToolEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Tool",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": (v22/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "concreteType": "PortfolioProjectOrganizationConnection",
  "kind": "LinkedField",
  "name": "organizations",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PortfolioProjectOrganizationEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Organization",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": (v22/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "animated",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "height",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sizeBytes",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uid",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "width",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "concreteType": "ContraImage",
  "kind": "LinkedField",
  "name": "image",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v27/*: any*/),
    (v28/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "originalFormat",
      "storageKey": null
    },
    (v29/*: any*/),
    (v30/*: any*/),
    (v31/*: any*/)
  ],
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "style",
  "storageKey": null
},
v34 = [
  {
    "kind": "Variable",
    "name": "username",
    "variableName": "username"
  }
],
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "onlyVisibleToRecipient",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPositiveReview",
  "storageKey": null
},
v37 = {
  "kind": "InlineFragment",
  "selections": [
    (v32/*: any*/)
  ],
  "type": "PortfolioProjectImageCover",
  "abstractKey": null
},
v38 = {
  "kind": "InlineFragment",
  "selections": [
    (v33/*: any*/)
  ],
  "type": "PortfolioProjectTextCover",
  "abstractKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "cover",
  "plural": false,
  "selections": [
    (v26/*: any*/),
    (v37/*: any*/),
    (v38/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ContraVideo",
          "kind": "LinkedField",
          "name": "video",
          "plural": false,
          "selections": [
            (v30/*: any*/),
            (v2/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "PortfolioProjectVideoCover",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v40 = [
  (v2/*: any*/),
  (v30/*: any*/)
],
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "interval",
  "storageKey": null
},
v43 = [
  (v2/*: any*/),
  (v20/*: any*/)
],
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "developmentSlug",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v46 = [
  (v2/*: any*/),
  (v30/*: any*/),
  (v19/*: any*/)
],
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isLive",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProjectPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PortfolioProject",
        "kind": "LinkedField",
        "name": "portfolioProjectBySlug",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserProfile",
            "kind": "LinkedField",
            "name": "userProfile",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v15/*: any*/),
              (v17/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UserProfileExternalLinkConnection",
                "kind": "LinkedField",
                "name": "externalLinks",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserProfileExternalLinkEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserProfileExternalLink",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v18/*: any*/),
                          (v19/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SocialMediaSite",
                            "kind": "LinkedField",
                            "name": "socialMediaSite",
                            "plural": false,
                            "selections": [
                              (v20/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "Footer_userProfile"
              }
            ],
            "storageKey": null
          },
          (v23/*: any*/),
          (v24/*: any*/),
          (v25/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "PortfolioProjectOtherProjectConnection",
            "kind": "LinkedField",
            "name": "otherPortfolioProjectsByUser",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PortfolioProjectOtherProjectEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PortfolioProject",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "cover",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v26/*: any*/),
                              (v32/*: any*/)
                            ],
                            "type": "PortfolioProjectImageCover",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v26/*: any*/),
                              (v33/*: any*/)
                            ],
                            "type": "PortfolioProjectTextCover",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v26/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ContraVideo",
                                "kind": "LinkedField",
                                "name": "video",
                                "plural": false,
                                "selections": [
                                  (v30/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "PortfolioProjectVideoCover",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v23/*: any*/),
                      (v25/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Project_portfolioProject"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v34/*: any*/),
        "concreteType": "UserProfile",
        "kind": "LinkedField",
        "name": "userProfileByUsername",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "UserProfile_userProfile"
          }
        ],
        "storageKey": null
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "UrlMetaData_queryFragment"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "IndependentPortfolioTemplates_queryFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProjectPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PortfolioProject",
        "kind": "LinkedField",
        "name": "portfolioProjectBySlug",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserProfile",
            "kind": "LinkedField",
            "name": "userProfile",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v15/*: any*/),
              (v17/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UserProfileExternalLinkConnection",
                "kind": "LinkedField",
                "name": "externalLinks",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserProfileExternalLinkEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserProfileExternalLink",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v18/*: any*/),
                          (v19/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SocialMediaSite",
                            "kind": "LinkedField",
                            "name": "socialMediaSite",
                            "plural": false,
                            "selections": [
                              (v20/*: any*/),
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UserReviewConnection",
                "kind": "LinkedField",
                "name": "userReviews",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserReviewEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserReview",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v35/*: any*/),
                          (v36/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v23/*: any*/),
          (v24/*: any*/),
          (v25/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "PortfolioProjectOtherProjectConnection",
            "kind": "LinkedField",
            "name": "otherPortfolioProjectsByUser",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PortfolioProjectOtherProjectEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PortfolioProject",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v39/*: any*/),
                      (v23/*: any*/),
                      (v25/*: any*/),
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "contributionYear",
            "storageKey": null
          },
          (v39/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v34/*: any*/),
        "concreteType": "UserProfile",
        "kind": "LinkedField",
        "name": "userProfileByUsername",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v10/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "location",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "profileDisplayType",
            "storageKey": null
          },
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bio",
            "storageKey": null
          },
          (v7/*: any*/),
          (v11/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasActivePortfolio",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "primaryJobPostingCategory",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "topIndependentStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BrandCustomization",
            "kind": "LinkedField",
            "name": "brandCustomization",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "BrandCustomizationLogo",
                "kind": "LinkedField",
                "name": "logo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContraImage",
                    "kind": "LinkedField",
                    "name": "logoImage",
                    "plural": false,
                    "selections": (v40/*: any*/),
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "tagContexts",
                "value": [
                  "SERVICE",
                  "PROJECT"
                ]
              },
              {
                "kind": "Literal",
                "name": "tagTypes",
                "value": [
                  "ROLE_TAG"
                ]
              }
            ],
            "concreteType": null,
            "kind": "LinkedField",
            "name": "tags",
            "plural": true,
            "selections": [
              (v26/*: any*/),
              (v2/*: any*/),
              (v21/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Role",
                    "kind": "LinkedField",
                    "name": "role",
                    "plural": false,
                    "selections": (v22/*: any*/),
                    "storageKey": null
                  }
                ],
                "type": "UserProfileRoleTag",
                "abstractKey": null
              }
            ],
            "storageKey": "tags(tagContexts:[\"SERVICE\",\"PROJECT\"],tagTypes:[\"ROLE_TAG\"])"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ContraImage",
            "kind": "LinkedField",
            "name": "avatarImage",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v30/*: any*/),
              (v28/*: any*/),
              (v19/*: any*/),
              (v31/*: any*/),
              (v27/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v16/*: any*/),
            "concreteType": "UserProfilePortfolioProjectConnection",
            "kind": "LinkedField",
            "name": "portfolioProjects",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserProfilePortfolioProjectEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PortfolioProject",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "cover",
                        "plural": false,
                        "selections": [
                          (v26/*: any*/),
                          (v37/*: any*/),
                          (v38/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v2/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v23/*: any*/),
                      (v25/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "portfolioProjects(excludeDrafts:true,type:\"PROJECT\")"
          },
          {
            "alias": null,
            "args": (v13/*: any*/),
            "concreteType": "UserProfileProductizedServiceConnection",
            "kind": "LinkedField",
            "name": "productizedServices",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserProfileProductizedServiceEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProductizedService",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProductizedServicePortfolioProjectConnection",
                        "kind": "LinkedField",
                        "name": "portfolioProjects",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProductizedServicePortfolioProjectEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PortfolioProject",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  (v4/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "productizedServiceType",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProductizedServiceDuration",
                        "kind": "LinkedField",
                        "name": "duration",
                        "plural": false,
                        "selections": [
                          (v41/*: any*/),
                          (v42/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProductizedServicePrice",
                        "kind": "LinkedField",
                        "name": "price",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "type",
                            "storageKey": null
                          },
                          (v42/*: any*/),
                          (v41/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "timeline",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "productizedServices(excludeDrafts:true)"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserProfileExternalLinkConnection",
            "kind": "LinkedField",
            "name": "externalLinks",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserProfileExternalLinkEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserProfileExternalLink",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v18/*: any*/),
                      (v19/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SocialMediaSite",
                        "kind": "LinkedField",
                        "name": "socialMediaSite",
                        "plural": false,
                        "selections": (v43/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IndependentPortfolioTemplateTheme",
            "kind": "LinkedField",
            "name": "independentPortfolioTemplateTheme",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v44/*: any*/),
              (v45/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "IndependentPortfolioTemplate",
                "kind": "LinkedField",
                "name": "template",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v44/*: any*/),
                  (v45/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ThemeCustomization",
                "kind": "LinkedField",
                "name": "themeCustomization",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ThemeFontPack",
                    "kind": "LinkedField",
                    "name": "accentFontPack",
                    "plural": false,
                    "selections": (v43/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "backgroundColor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ThemeBackgroundStyle",
                    "kind": "LinkedField",
                    "name": "backgroundStyle",
                    "plural": false,
                    "selections": (v43/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ThemeFontPack",
                    "kind": "LinkedField",
                    "name": "bodyFontPack",
                    "plural": false,
                    "selections": (v43/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "fontColorPrimary",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "fontColorSecondary",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ThemeFontPack",
                    "kind": "LinkedField",
                    "name": "fontPack",
                    "plural": false,
                    "selections": (v43/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ThemeFontPack",
                    "kind": "LinkedField",
                    "name": "headingFontPack",
                    "plural": false,
                    "selections": (v43/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CustomizationLayout",
                    "kind": "LinkedField",
                    "name": "layout",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ThemeProjectLayout",
                        "kind": "LinkedField",
                        "name": "projectsVariant",
                        "plural": false,
                        "selections": (v43/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ThemeServiceLayout",
                        "kind": "LinkedField",
                        "name": "servicesVariant",
                        "plural": false,
                        "selections": (v43/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContraImage",
                    "kind": "LinkedField",
                    "name": "logoImage",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v30/*: any*/),
                      (v29/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserReviewConnection",
            "kind": "LinkedField",
            "name": "userReviews",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "count",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UserReviewEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserReview",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "commentOnlyVisibleToRecipient",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "createdAt",
                        "storageKey": null
                      },
                      (v35/*: any*/),
                      (v36/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "reviewText",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserProfile",
                        "kind": "LinkedField",
                        "name": "author",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v2/*: any*/),
                          (v8/*: any*/),
                          (v9/*: any*/),
                          (v10/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "onboardingType",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ContraImage",
                            "kind": "LinkedField",
                            "name": "avatarImage",
                            "plural": false,
                            "selections": (v46/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Organization",
                            "kind": "LinkedField",
                            "name": "organization",
                            "plural": false,
                            "selections": [
                              (v21/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ContraImage",
                                "kind": "LinkedField",
                                "name": "logoImage",
                                "plural": false,
                                "selections": (v46/*: any*/),
                                "storageKey": null
                              },
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserReviewAssociatedWork",
                        "kind": "LinkedField",
                        "name": "associatedWork",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PaidProjectProfile",
                            "kind": "LinkedField",
                            "name": "paidProjectProfile",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "UserProfile",
                                "kind": "LinkedField",
                                "name": "client",
                                "plural": false,
                                "selections": (v14/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PortfolioProject",
                            "kind": "LinkedField",
                            "name": "portfolioProject",
                            "plural": false,
                            "selections": (v14/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProductizedService",
                            "kind": "LinkedField",
                            "name": "productizedService",
                            "plural": false,
                            "selections": (v14/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "url",
            "variableName": "url"
          }
        ],
        "concreteType": "UrlMetaData",
        "kind": "LinkedField",
        "name": "urlMetaData",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "facebookImageUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "twitterImageUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canonicalUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "openGraphImageAltText",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UrlMetadataImageDimensions",
            "kind": "LinkedField",
            "name": "openGraphImageDimensions",
            "plural": false,
            "selections": [
              (v31/*: any*/),
              (v28/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "IndependentPortfolioTemplateConnection",
        "kind": "LinkedField",
        "name": "independentPortfolioTemplates",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "IndependentPortfolioTemplateEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "IndependentPortfolioTemplate",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v45/*: any*/),
                  (v44/*: any*/),
                  (v47/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "accessLevel",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "IndependentPortfolioTemplateThemeConnection",
                    "kind": "LinkedField",
                    "name": "themes",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "IndependentPortfolioTemplateThemeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "IndependentPortfolioTemplateTheme",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v45/*: any*/),
                              (v44/*: any*/),
                              (v47/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "generatedPreviewImage",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ContraImage",
                                "kind": "LinkedField",
                                "name": "previewImage",
                                "plural": false,
                                "selections": (v40/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ac4135d36d79f34dbd1281ad6e64d4e1",
    "id": null,
    "metadata": {},
    "name": "ProjectPageQuery",
    "operationKind": "query",
    "text": "query ProjectPageQuery(\n  $slug: String!\n  $url: String!\n  $username: String!\n) {\n  portfolioProjectBySlug(slug: $slug) {\n    id\n    analyticsId\n    slug\n    title\n    blocknoteContent\n    visitorCanEdit\n    userProfile {\n      id\n      firstName\n      lastName\n      displayUsername\n      generalInquiryCtaIsVisible\n      productizedServices(excludeDrafts: true) {\n        edges {\n          node {\n            id\n          }\n        }\n      }\n      portfolioProjects(type: PROJECT, excludeDrafts: true) {\n        edges {\n          node {\n            id\n          }\n        }\n      }\n      externalLinks {\n        edges {\n          node {\n            id\n            label\n            url\n            socialMediaSite {\n              nid\n              id\n            }\n          }\n        }\n      }\n      ...Footer_userProfile\n    }\n    roles {\n      edges {\n        node {\n          id\n          name\n        }\n      }\n    }\n    tools {\n      edges {\n        node {\n          id\n          name\n        }\n      }\n    }\n    organizations {\n      edges {\n        node {\n          id\n          name\n        }\n      }\n    }\n    otherPortfolioProjectsByUser {\n      edges {\n        node {\n          id\n          slug\n          title\n          cover {\n            __typename\n            ... on PortfolioProjectImageCover {\n              __typename\n              image {\n                id\n                animated\n                height\n                originalFormat\n                sizeBytes\n                uid\n                width\n              }\n            }\n            ... on PortfolioProjectTextCover {\n              __typename\n              style\n            }\n            ... on PortfolioProjectVideoCover {\n              __typename\n              video {\n                uid\n                id\n              }\n            }\n          }\n          roles {\n            edges {\n              node {\n                id\n                name\n              }\n            }\n          }\n          organizations {\n            edges {\n              node {\n                id\n                name\n              }\n            }\n          }\n        }\n      }\n    }\n    ...Project_portfolioProject\n  }\n  userProfileByUsername(username: $username) {\n    id\n    ...UserProfile_userProfile\n  }\n  ...UrlMetaData_queryFragment\n  ...IndependentPortfolioTemplates_queryFragment\n}\n\nfragment Footer_userProfile on UserProfile {\n  id\n  visitorCanEdit\n  portfolioProjects(type: PROJECT, excludeDrafts: true) {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n  productizedServices(excludeDrafts: true) {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n  userReviews {\n    edges {\n      node {\n        id\n        onlyVisibleToRecipient\n        isPositiveReview\n      }\n    }\n  }\n}\n\nfragment IndependentPortfolioTemplates_queryFragment on Query {\n  independentPortfolioTemplates {\n    edges {\n      node {\n        id\n        displayName\n        developmentSlug\n        isLive\n        accessLevel\n        themes {\n          edges {\n            node {\n              id\n              displayName\n              developmentSlug\n              isLive\n              generatedPreviewImage\n              previewImage {\n                id\n                uid\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment OtherProjects_portfolioProjectOtherProjectConnection on PortfolioProjectOtherProjectConnection {\n  edges {\n    node {\n      analyticsId\n      id\n      slug\n      title\n      roles {\n        edges {\n          node {\n            id\n            name\n          }\n        }\n      }\n      organizations {\n        edges {\n          node {\n            id\n            name\n          }\n        }\n      }\n      cover {\n        __typename\n        ... on PortfolioProjectImageCover {\n          __typename\n          image {\n            id\n            animated\n            height\n            originalFormat\n            sizeBytes\n            uid\n            width\n          }\n        }\n        ... on PortfolioProjectTextCover {\n          __typename\n          style\n        }\n        ... on PortfolioProjectVideoCover {\n          __typename\n          video {\n            uid\n            id\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment ProjectHeader_portfolioProject on PortfolioProject {\n  id\n  title\n  contributionYear\n  organizations {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n  roles {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n  tools {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n}\n\nfragment Project_portfolioProject on PortfolioProject {\n  analyticsId\n  id\n  slug\n  title\n  blocknoteContent\n  contributionYear\n  cover {\n    __typename\n    ... on PortfolioProjectImageCover {\n      __typename\n      image {\n        id\n        animated\n        height\n        originalFormat\n        sizeBytes\n        uid\n        width\n      }\n    }\n    ... on PortfolioProjectTextCover {\n      __typename\n      style\n    }\n    ... on PortfolioProjectVideoCover {\n      __typename\n      video {\n        uid\n        id\n      }\n    }\n  }\n  userProfile {\n    id\n    firstName\n    displayUsername\n    generalInquiryCtaIsVisible\n    productizedServices(excludeDrafts: true) {\n      edges {\n        node {\n          id\n        }\n      }\n    }\n    portfolioProjects(type: PROJECT, excludeDrafts: true) {\n      edges {\n        node {\n          id\n        }\n      }\n    }\n    externalLinks {\n      edges {\n        node {\n          id\n          label\n          url\n          socialMediaSite {\n            nid\n            id\n          }\n        }\n      }\n    }\n    ...Footer_userProfile\n  }\n  roles {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n  tools {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n  organizations {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n  otherPortfolioProjectsByUser {\n    edges {\n      node {\n        analyticsId\n        id\n        slug\n        title\n        cover {\n          __typename\n          ... on PortfolioProjectImageCover {\n            __typename\n            image {\n              id\n              animated\n              height\n              originalFormat\n              sizeBytes\n              uid\n              width\n            }\n          }\n          ... on PortfolioProjectTextCover {\n            __typename\n            style\n          }\n        }\n        roles {\n          edges {\n            node {\n              id\n              name\n            }\n          }\n        }\n        organizations {\n          edges {\n            node {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n    ...OtherProjects_portfolioProjectOtherProjectConnection\n  }\n  ...ProjectHeader_portfolioProject\n}\n\nfragment UrlMetaData_queryFragment on Query {\n  urlMetaData(url: $url) {\n    title\n    description\n    facebookImageUrl\n    twitterImageUrl\n    canonicalUrl\n    openGraphImageAltText\n    updatedAt\n    openGraphImageDimensions {\n      width\n      height\n    }\n  }\n}\n\nfragment UserProfile_userProfile on UserProfile {\n  id\n  analyticsId\n  displayUsername\n  firstName\n  lastName\n  location\n  profileDisplayType\n  title\n  bio\n  visitorCanEdit\n  generalInquiryCtaIsVisible\n  hasActivePortfolio\n  primaryJobPostingCategory\n  topIndependentStatus\n  brandCustomization {\n    logo {\n      logoImage {\n        id\n        uid\n      }\n      id\n    }\n    id\n  }\n  tags(tagTypes: [ROLE_TAG], tagContexts: [SERVICE, PROJECT]) {\n    __typename\n    id\n    name\n    ... on UserProfileRoleTag {\n      role {\n        id\n        name\n      }\n    }\n  }\n  avatarImage {\n    id\n    uid\n    height\n    url\n    width\n    animated\n  }\n  portfolioProjects(type: PROJECT, excludeDrafts: true) {\n    edges {\n      node {\n        analyticsId\n        cover {\n          __typename\n          ... on PortfolioProjectImageCover {\n            __typename\n            image {\n              id\n              animated\n              height\n              originalFormat\n              sizeBytes\n              uid\n              width\n            }\n          }\n          ... on PortfolioProjectTextCover {\n            __typename\n            style\n          }\n        }\n        id\n        slug\n        title\n        roles {\n          edges {\n            node {\n              id\n              name\n            }\n          }\n        }\n        organizations {\n          edges {\n            node {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n  productizedServices(excludeDrafts: true) {\n    edges {\n      node {\n        id\n        slug\n        title\n        portfolioProjects {\n          edges {\n            node {\n              id\n              slug\n            }\n          }\n        }\n        productizedServiceType\n        duration {\n          amount\n          interval\n        }\n        price {\n          type\n          interval\n          amount\n          timeline\n        }\n      }\n    }\n  }\n  externalLinks {\n    edges {\n      node {\n        id\n        label\n        url\n        socialMediaSite {\n          id\n          nid\n        }\n      }\n    }\n  }\n  independentPortfolioTemplateTheme {\n    id\n    developmentSlug\n    displayName\n    template {\n      id\n      developmentSlug\n      displayName\n    }\n    themeCustomization {\n      id\n      accentFontPack {\n        id\n        nid\n      }\n      backgroundColor\n      backgroundStyle {\n        id\n        nid\n      }\n      bodyFontPack {\n        id\n        nid\n      }\n      fontColorPrimary\n      fontColorSecondary\n      fontPack {\n        id\n        nid\n      }\n      headingFontPack {\n        id\n        nid\n      }\n      layout {\n        projectsVariant {\n          id\n          nid\n        }\n        servicesVariant {\n          id\n          nid\n        }\n      }\n      logoImage {\n        id\n        uid\n        sizeBytes\n      }\n    }\n  }\n  userReviews {\n    count\n    edges {\n      node {\n        id\n        commentOnlyVisibleToRecipient\n        createdAt\n        onlyVisibleToRecipient\n        isPositiveReview\n        reviewText\n        author {\n          analyticsId\n          id\n          firstName\n          lastName\n          displayUsername\n          onboardingType\n          avatarImage {\n            id\n            uid\n            url\n          }\n          organization {\n            name\n            logoImage {\n              id\n              uid\n              url\n            }\n            id\n          }\n        }\n        associatedWork {\n          paidProjectProfile {\n            id\n            client {\n              id\n            }\n          }\n          portfolioProject {\n            id\n          }\n          productizedService {\n            id\n          }\n        }\n        ...UserReview_userReview\n      }\n    }\n  }\n}\n\nfragment UserReview_userReview on UserReview {\n  id\n  commentOnlyVisibleToRecipient\n  createdAt\n  onlyVisibleToRecipient\n  isPositiveReview\n  reviewText\n  author {\n    analyticsId\n    id\n    firstName\n    lastName\n    displayUsername\n    onboardingType\n    avatarImage {\n      id\n      uid\n      url\n    }\n    organization {\n      name\n      logoImage {\n        id\n        uid\n        url\n      }\n      id\n    }\n  }\n  associatedWork {\n    paidProjectProfile {\n      id\n      client {\n        id\n      }\n    }\n    portfolioProject {\n      id\n    }\n    productizedService {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0cfa03df727e0201ec6eb7e91c4665a6";

export default node;
